/**
 * Lightweight delete-confirmation modal.
 */
import React from 'react'
import { Modal, ModalDialog, DialogTitle, DialogContent, DialogActions, Button, Alert } from '@mui/joy'

interface Props {
    open: boolean
    title: string
    message: React.ReactNode
    confirmLabel?: string
    loading: boolean
    onConfirm: () => void
    onClose: () => void
}

export default function ConfirmDeleteModal({ open, title, message, confirmLabel = 'Delete', loading, onConfirm, onClose }: Props) {
    return (
        <Modal open={open} onClose={() => !loading && onClose()}>
            <ModalDialog variant="outlined" role="alertdialog" sx={{ maxWidth: 440 }}>
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    <Alert color="danger" variant="soft">
                        {message}
                    </Alert>
                </DialogContent>
                <DialogActions>
                    <Button variant="plain" color="neutral" onClick={onClose} disabled={loading}>
                        Cancel
                    </Button>
                    <Button variant="solid" color="danger" loading={loading} onClick={onConfirm}>
                        {confirmLabel}
                    </Button>
                </DialogActions>
            </ModalDialog>
        </Modal>
    )
}
